const getParamForOption = (optionTypeName, selectedOptionName) =>
  optionTypeName && selectedOptionName
    ? `${optionTypeName.toLowerCase()}=${selectedOptionName
        .toLowerCase()
        .split(' ')
        .join('-')}`
    : '';

export default getParamForOption;
